import { Box } from '@mui/material';
import SpreedlyContext from 'components/payment/spreedly/spreedly.context';
import ThreeDS2Modal from 'pages/payments/threeds2/threeds2-modal/threeds2-modal.component';
import { useContext } from 'react';
import SpreedlyCheckoutButtons from '../spreedly-checkout-buttons.component';
import SpreedlyCheckoutButtonsProvider from './spreedly-checkout-buttons-provider/spreedly-checkout-buttons-provider.component';

const SpreedlyCheckoutButtonsContainer = props => {
  const { spreedlyScriptLoading } = useContext(SpreedlyContext);

  return (
    <SpreedlyCheckoutButtonsProvider>
      <Box data-testid="CheckoutButtons.Grid">
        <SpreedlyCheckoutButtons
          {...props}
          scriptLoading={spreedlyScriptLoading}
        />
      </Box>
      <ThreeDS2Modal />
    </SpreedlyCheckoutButtonsProvider>
  );
};

export default SpreedlyCheckoutButtonsContainer;
